import { Log, UserManager } from 'oidc-client-ts'

import IDENTITY_CONFIG from './authConst'

export default class AuthService {
  UserManager

  constructor() {
    this.UserManager = new UserManager({
      ...IDENTITY_CONFIG,
    })

    if (process.env.ENABLE_OIDC_LOG) {
      Log.setLogger(console)
      Log.setLevel(Log.DEBUG)
    }

    this.UserManager.events.addSilentRenewError(() => {})

    this.UserManager.events.addAccessTokenExpired(() => {
      this.signinSilent()
    })
  }

  hasAuthParams = (location = window.location) => {
    // response_mode: query
    let searchParams = new URLSearchParams(location.search)
    if ((searchParams.get('code') || searchParams.get('error')) && searchParams.get('state')) {
      return true
    }

    // response_mode: fragment
    searchParams = new URLSearchParams(location.hash.replace('#', '?'))
    if ((searchParams.get('code') || searchParams.get('error')) && searchParams.get('state')) {
      return true
    }

    return false
  }

  signinRedirectCallback = () => this.UserManager.signinRedirectCallback()

  getUser = async () => {
    const user = await this.UserManager.getUser()
    if (!user) {
      return this.UserManager.signinRedirectCallback()
    }
    return user
  }

  private userInfoUrl

  isAuthenticatedUserEndpoint = async (): Promise<boolean> => {
    const user = await this.UserManager.getUser()
    await fetch(`${this.userInfoUrl}?access_token=${user.access_token}`)
      .then(response => response.ok)
      .catch(() => false)
    return false
  }

  parseJwt = token => {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64))
  }

  signinRedirect = () => {
    localStorage.setItem('redirectUri', IDENTITY_CONFIG.redirect_uri)
    this.UserManager.signinRedirect({})
  }

  isAuthenticated = () => {
    const oidcStorage = JSON.parse(
      sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`),
    )

    return !!oidcStorage && !!oidcStorage.access_token
  }

  getProfile = () => {
    const oidcStorage = JSON.parse(
      sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`),
    )

    if (oidcStorage) {
      return oidcStorage.profile
    }
    return undefined
  }

  signinSilent = () => {
    this.UserManager.signinSilent()
  }

  signinSilentCallback = () => {
    this.UserManager.signinSilentCallback()
  }

  createSigninRequest = () => this.UserManager.createSigninRequest()

  logout = () => {
    this.UserManager.signoutRedirect({
      id_token_hint: localStorage.getItem('id_token'),
    })
    localStorage.clear()
    this.UserManager.clearStaleState()
  }

  signoutRedirectCallback = () => {
    this.UserManager.signoutRedirectCallback().then(() => {
      localStorage.clear()
      window.location.replace(process.env.REACT_APP_PUBLIC_URL)
    })
    this.UserManager.clearStaleState()
  }
}
